import { formatNumber } from "@angular/common";
import { Component, Input, QueryList, ViewChildren } from "@angular/core";
import { AbstractControl, UntypedFormArray, UntypedFormGroup } from "@angular/forms";
import { MatExpansionPanel } from "@angular/material/expansion";

import { Ejendomsfaktor, EjendomsfaktorDefinition } from "@e-forsyning/common/ejendomsfaktor";

@Component({
    selector: "ejendomsfaktor-liste",
    templateUrl: "./ejendomsfaktor-liste.component.html",
    styleUrls: ["./ejendomsfaktor-liste.component.scss"]
})
export class EjendomsfaktorListeComponent {
    @Input() public formGroup: UntypedFormGroup;
    @Input() public ejendomsfaktorDefinitioner: EjendomsfaktorDefinition[];

    @ViewChildren(MatExpansionPanel) public expansionPanels: QueryList<MatExpansionPanel>;

    public get ejendomsfaktorer(): AbstractControl[] {
        return (this.formGroup.get("ejendomsfaktorer") as UntypedFormArray).controls;
    }

    public hentEjendomsfaktorVaerdi(ejendomsfaktor: Ejendomsfaktor): string {
        const definition = this.hentEjendomsfaktorDefinition(ejendomsfaktor);
        if (!definition) {
            return "";
        }

        const valgmulighed = definition.valgmuligheder.find((v) => v.id === ejendomsfaktor.vaerdi.aktuel);
        const enhed = valgmulighed ? "" : definition.enhed;
        const vaerdi = (valgmulighed && valgmulighed.navn) || this.formatterVaerdi(ejendomsfaktor.vaerdi.aktuel, definition.datatype);
        return vaerdi + " " + enhed;
    }

    public formatterVaerdi(vaerdi: string, datatype: number): string {
        const replaceDotPattern = /\./g; // Det fungerer åbenbart ikke hvis den laves inline i replace()-metoden.
        const result = vaerdi === null ? "" : vaerdi;
        if (datatype === 10) {
            return result === "" ? "" : formatNumber(parseFloat(result), "da").replace(replaceDotPattern, "");
        }
        return result.toString();
    }

    public hentEjendomsfaktorDefinition(ejendomsfaktor: Ejendomsfaktor): EjendomsfaktorDefinition {
        if (!ejendomsfaktor) {
            return null;
        }

        const result = this.ejendomsfaktorDefinitioner.find((d) => d.id === ejendomsfaktor.definitionId);
        return result;
    }
}
